import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much does drone crop spraying cost in South Florida?",
    a: "Pricing depends on acreage, crop, chemical and access. Most jobs in Homestead and Miami-Dade run $15–$25 per acre for spraying and $10–$15 per acre for seeding. Call us for a free site-specific quote.",
  },
  {
    q: "Are AeroAcres drone pilots FAA-licensed?",
    a: "Yes. Every pilot holds an FAA Part 107 license combined with a Part 137 agricultural operator certificate, and our applicators are licensed by the Florida Department of Agriculture (FDACS).",
  },
  {
    q: "What chemicals can drones legally spray on crops?",
    a: "EPA-labeled pesticides, herbicides, fungicides, biologicals and foliar fertilizers — anything approved for aerial application. We source the chemical or apply yours, with full chain-of-custody logging.",
  },
  {
    q: "How fast can you schedule a drone spray in Homestead or Miami-Dade?",
    a: "For emergencies (pest outbreaks, disease pressure) we typically mobilize within 24–48 hours across Homestead, Florida City and Miami-Dade. Scheduled programs are booked weeks in advance.",
  },
  {
    q: "Do drones work for avocado and mango groves?",
    a: "Absolutely. Drones excel in dense canopies like avocado, mango and lime where traditional ground rigs struggle. Downwash forces chemical into the underside of leaves where pests hide.",
  },
  {
    q: "What weather conditions stop a drone spray?",
    a: "We won't fly in sustained winds over 10 mph, during rain, or within 2 hours of forecast rain — drift control and chemical efficacy come first. We track local weather and reschedule at no charge.",
  },
  {
    q: "Do you provide a coverage report after spraying?",
    a: "Yes. Every job includes a flight log, GPS swath map, applied-rate map, weather snapshot and timestamped proof of application — perfect for organic certification audits and crop insurance documentation.",
  },
  {
    q: "Which areas of Florida does AeroAcres service?",
    a: "Primary service area is Homestead, Florida City, Princeton, Naranja, Redland Agricultural Area and greater Miami-Dade County. We also take larger projects across Broward, Collier and the Glades.",
  },
  {
    q: "Is drone spraying better than a traditional crop duster?",
    a: "For small to mid-size fields under 200 acres, drones are typically faster to mobilize, cheaper, and far more precise. Drones avoid the soil compaction of tractors and the high cost of manned aircraft.",
  },
  {
    q: "How much chemical do drones save compared to ground rigs?",
    a: "Most growers see a 20–30% reduction in chemical use thanks to GPS-guided swath control, electrostatic nozzles and tight overlap management.",
  },
  {
    q: "Can drones spray nurseries and ornamental crops in the Redland?",
    a: "Yes — we routinely spray ornamental nurseries in the Redland Agricultural Area. Dense rows, mixed canopy heights and tight buffers are exactly where drones outperform conventional sprayers.",
  },
  {
    q: "Do I need a permit to have my field sprayed by drone?",
    a: "You do not. The aerial applicator (AeroAcres) carries the FAA Part 137 certificate and Florida FDACS license. We handle all regulatory paperwork on your behalf.",
  },
  {
    q: "How large of a field can drones spray in one day?",
    a: "A two-drone team comfortably covers 80–120 acres per day depending on crop, chemical and field access. Larger blocks are scheduled across multiple flight crews.",
  },
  {
    q: "Are drone sprays safe for pollinators?",
    a: "Drones can be safer for pollinators when scheduled around bee foraging windows and combined with reduced-risk chemistries. We coordinate with on-site beekeepers whenever applicable.",
  },
  {
    q: "How do I get a free drone spraying quote in Florida?",
    a: "Submit the form on this page or call AeroAcres directly. We'll return pricing, available slots and the recommended chemical program within 24 hours.",
  },
  {
    q: "Do you offer recurring spray programs?",
    a: "Yes. Many of our Homestead avocado and Miami-Dade tomato growers run multi-month recurring programs — we schedule, source the chemical and apply on a fixed cadence.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-accent mb-4">Frequently asked</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary font-bold leading-tight">
            Everything growers ask about <span className="text-accent">drone spraying.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-border rounded-2xl px-6 bg-card hover:border-accent/40 transition-colors"
            >
              <AccordionTrigger className="text-left font-display text-base md:text-lg font-semibold text-primary hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5 text-sm md:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
